export default () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4 6L8 6" stroke="#5E6E7D" stroke-width="2" stroke-linecap="round" />
	</svg>
);
